export default __webpack_public_path__ + "static/media/Mayor-Glass.fe551d36.jpg";